import type { HelpModuleType } from "@/redux/helpModule/helpTypes";

export const initialState: HelpModuleType = {
  success: null,
  editSuccess: null,
  addSuccess: null,
  error: null,
  statusCode: null,
  message: "",
  addMessage: "",
  editMessage: "",
  fetching: false,
  helpModuleList: [],
  helpModuleTotalCount: 0,
};
